export const VOIP_CAMPAIGN_FILTERS = {
  ALL: 'all_campaigns',
  MAPPED: 'mapped',
  UNMAPPED: 'unmapped',
}

export const TABLE_COLUMNS = [
  { accessor: 'voipCampaignName', isSearchable: true, label: 'VoIP Campaign Name' },
  { accessor: 'campaignConfigName', isSearchable: true, label: 'Playbook' },
]

export const FILTER_OPTIONS = [
  { value: VOIP_CAMPAIGN_FILTERS.ALL, label: 'All Campaigns' },
  { value: VOIP_CAMPAIGN_FILTERS.UNMAPPED, label: 'Unmapped' },
  { value: VOIP_CAMPAIGN_FILTERS.MAPPED, label: 'Mapped' },
]
